/*
 * View for the content mapping modal, which is basically just the contentMapping module
 * inside a modal with OK and Cancel buttons
 */

define([
  "marionette",
  "modules/shared/contentMappingModal/template/contentMappingModalTemplate.html",
], function (Marionette, ContentMappingModalTemplate) {
  var ContentMappingModalView = {};

  ContentMappingModalView.contentMappingModalLayout = Marionette.Layout.extend({
    template: ContentMappingModalTemplate,
    regions: {
      contentMappingArea: "#contentMappingArea",
    },
    triggers: {
      "click #doneButton": "done",
      "click #cancelButton": "cancel",
    },
    clearError: function () {
      this.$el.find("#contentError").html("");
    },
    contentError: function (errorMessage) {
      this.$el
        .find("#contentError")
        .html('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
  });

  return ContentMappingModalView;
});
